import { render, staticRenderFns } from "./createSuccess.vue?vue&type=template&id=3ba78568"
import script from "./createSuccess.vue?vue&type=script&lang=js"
export * from "./createSuccess.vue?vue&type=script&lang=js"
import style0 from "./createSuccess.vue?vue&type=style&index=0&id=3ba78568&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports